import React from "react";
import { Link } from "react-router-dom";
import { MoireMark } from "@/components/MoireLogo";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-5">
      <MoireMark size={56} />
      <h1 className="font-serif text-7xl text-[#F5F2EA] mt-8">404</h1>
      <p className="font-serif italic text-2xl text-[#C8A97E] mt-2">This look wandered off.</p>
      <p className="font-sans text-sm text-[#8A8170] mt-4 max-w-sm">The page you're after isn't here — but your next great pairing is one snap away.</p>
      <Link to="/" data-testid="notfound-home"
        className="mt-10 border border-[#C8A97E] text-[#C8A97E] px-8 py-4 font-sans text-xs tracking-wider uppercase hover:bg-[#C8A97E] hover:text-[#0D0D0D] transition-colors">
        Back to MOIRÉ
      </Link>
    </div>
  );
}
